<template>
  <v-container>
    <h2>Total Users</h2>
    <v-card>
      <v-row class="ma-2">
        <v-col md="3">
          <v-autocomplete
            label="Company"
            :items="companyList"
            item-text="name_company"
            v-model="selectedCompany"
            item-value="id"
            @change="changeCompany"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-card>

<!-- Weekly Data -->
    <v-card color="grey lighten-4" flat tile class="mt-5" min-height="400px">
      <v-toolbar dense>
        <v-toolbar-title>Weekly Data</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('prev')">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>Previous Week</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('today')">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
          <span>This Week</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('next')">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>Next Week</span>
        </v-tooltip>
      </v-toolbar>
      <ChartAttendancePW
        v-if="!loadingPW"
        v-bind:companyId="selectedCompany"
        v-bind:companyName="companyName"
        v-bind:year="yearPW"
        v-bind:week="week"
      ></ChartAttendancePW>
      <v-card v-show="loadingPW" class="pt-0 mt-0">
        <v-row align="center" justify="center" style="height: 350px;">
          <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-row>
      </v-card>
    </v-card>
    
    <!-- Yearly Data -->
    <v-card color="grey lighten-4" flat tile class="mt-5" min-height="400px">
      <v-toolbar dense>
        <v-toolbar-title>Yearly Data</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('prev')">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>Previous Year</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('today')">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
          <span>This Year</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click="onYearChange('next')">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>Next Year</span>
        </v-tooltip>
      </v-toolbar>
      <ChartAttendancePC
        v-if="!loadingPC"
        v-bind:companyId="selectedCompany"
        v-bind:companyName="companyName"
        v-bind:year="year"
      ></ChartAttendancePC>
      <v-card v-show="loadingPC" class="pt-0 mt-0">
        <v-row align="center" justify="center" style="height: 350px;">
          <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
import moment from 'moment'
import ChartAttendancePC from './components/ChartAttendancePC'
import ChartAttendancePW from './components/ChartAttendancePW'
export default {
  name: "UserPerCompanyHistory",
  components: {
    ChartAttendancePC,
    ChartAttendancePW,
  },
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      companyList: [],
      selectedCompany: '',
      companyName: '',
      loadingPC: false,
      loadingPW: false,
      year: moment().year(),
      tmpDate: moment().week(moment().week()),
      week: moment().week(),
      yearPW: moment().year()
    }
  },
  methods: {
    async onYearChange(type) {
      switch (type) {
        case 'next':
          this.year++
          break
        case 'prev':
          this.year--
          break
        default:
          this.year = moment().year()
          break
      }
      this.refreshDataAttendance('pc')
    },
    async onWeekChange(type) {
      switch (type) {
        case 'next':
          this.tmpDate = this.tmpDate.add(1, 'week')
          this.week = this.tmpDate.week()
          this.yearPW = this.tmpDate.endOf('week').year()
          break
        case 'prev':
          this.tmpDate = this.tmpDate.subtract(1, 'week')
          this.week = this.tmpDate.week()
          this.yearPW = this.tmpDate.endOf('week').year()
          break
        default:
          this.tmpDate = moment().week(moment().week())
          this.week = this.tmpDate.week()
          this.yearPW = this.tmpDate.endOf('week').year()
          break
      }
      this.refreshDataAttendance('pw')
    },
    refreshDataAttendance(type) {
      if (type == 'pw') {
        this.loadingPW = true
      } else {
        this.loadingPC = true
      }
      setTimeout(() => {
        if (type == 'pw') {
          this.loadingPW = false
        } else {
          this.loadingPC = false
        }
      }, 10);
    },
     async getCompanyList() {
      const result = await this.$store.dispatch('getCompanyList')
      const data = []
      if (result) {
        result.map(item => {
          if (item.is_active) {
            data.push(item)
          }
        })
      }
      return data
    },
    changeCompany(id) {
      this.companyName = this.companyList.find(e => { return e.id == id }).name_company
      this.refreshDataAttendance('pc')
      this.refreshDataAttendance('pw')
    },
  },
  computed: {
  },
  async created() {
    this.companyList = await this.getCompanyList()
  },
  watch: {
  },
};
</script>
